import { Action, any, IOWidget } from 'widgets-for-react'
import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { CustomBlockData, isCustomBlockData, renderCustomBlock } from './custom_blocks/types.mod'
import { ExtraImages } from '../utils/extra_images.mod'
import { getMockedBlockRenderer, BlocksRenderer, renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { TemplateState } from '../../cms/page/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { faqOverview } from '../templates/faq_overview'
import { formOverview } from '../templates/form_overview'
import { PublicSiteState } from '../../public_site.main.mod'
import { postOverview } from '../templates/post_overview.mod'
import { productOverview } from '../templates/product_overview'


export let blocks_renderer = <customBlockData, extra_images, customPageData>() => ({
  ...getMockedBlockRenderer<customBlockData, extra_images, customPageData>()
})

export function pageDisplay_AUX(
  blocks: (Block | CustomBlock)[],
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>,
  public_state:PublicSiteState
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
> {
  return s => {

    return any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([
// TODO: Put product header here
        s.page.kind == 'loaded' &&
        s.page.value.extra_data.post.type == 'page' &&
        s.page.value.extra_data.post.template == 'update-overview' ? postOverview(s.page.value, 'update', public_state)
        : s.page.kind == 'loaded' &&
          s.page.value.extra_data.post.type == 'page' &&
          s.page.value.extra_data.post.template == 'faq-overview'
          ? faqOverview(s.page.value, s.page.value.extra_data.faqs, public_state)
          : s.page.kind == 'loaded' &&
            s.page.value.extra_data.post.type == 'page' &&
            s.page.value.extra_data.post.template == 'form-overview'
          ? formOverview(s.page.value, s.page.value.extra_data.forms, public_state).never()
            : s.page.kind == 'loaded' &&
              s.page.value.extra_data.post.type == 'page' &&
              s.page.value.extra_data.post.template == 'product-overview'
              ? productOverview(s.page.value, s.page.value.extra_data.products, public_state)
          : any<Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>>()([]),

          ...(s.blocks.filter(filterHeroForOverview(s.page)))
            .map((b, index) =>
              isCustomBlockData(b)
                ? renderCustomBlock(b, public_state, `key-${index}`)(s).map<
                    Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
                  >(a => s1 => {
                    let res = a(s1)
                    return { ...s1, images: res.images, blocks: res.blocks, custom_page_data: res.custom_page_data }
                  })
                : renderBlock(b, blocks_renderer, `key-${index}`)(s).map<
                    Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
                  >(a => s1 => {
                    let res = a(s1)
                    return { ...s1, images: res.images, blocks: res.blocks }
                  })
            )

            .valueSeq()
            .toArray()
        ])
      }
}

const filterHeroForOverview = (page) => (item) => {
  return page.kind == 'loaded' && (
    page.value.extra_data.post.template == 'update-overview' || 
    page.value.extra_data.post.template == 'faq-overview' ||
    page.value.extra_data.post.template == 'form-overview' ||
    page.value.extra_data.post.template == 'product-overview'
  ) && item.kind == "heroBlock" ? false : true
}

export let pageDisplay = (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
): ((
  b: (Block | CustomBlock)[],
  public_state:PublicSiteState
) => IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>>
>) => (b, public_state) => pageDisplay_AUX(b, blocks_renderer, public_state)



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/renderer.mod.tsx